import type { IActivityItem } from '@/entities/activity/types';
import ActivityListItemContent from '@/features/activity/ui/ListItemContent';
import { ShowCalendarProvider } from '@/features/product/contexts/ShowCalendarStoreContext';
import ProductListItem from '@/features/product/ui/ListItem';
import useExpanded from '@/hooks/useExpanded';

interface IProps {
  item: IActivityItem;
}
export default function ActivitySection({ item }: IProps) {
  const { idx: activityIdx, isExpanded, onToggleExpanded } = useExpanded();

  return (
    <ProductListItem
      title={item.title}
      description={item.description}
      descriptionGoto={item.descriptionGoto}
      price={item.price}
      isActive={item.isActive}
      shouldShow={isExpanded && activityIdx === item.idx}
      onToggleExpanded={onToggleExpanded(item.idx)}
    >
      <ShowCalendarProvider>
        <ActivityListItemContent
          idx={item.idx}
          shouldShow={isExpanded && activityIdx === item.idx}
        />
      </ShowCalendarProvider>
    </ProductListItem>
  );
}
